module.exports = __webpack_public_path__ + "img/weixin.77c8cd04.png";